import { agendamentoConstants } from '../constants';

export function agendamento(state = { agendamentos: {} }, action) {
  switch (action.type) {
    case agendamentoConstants.AGENDAMENTO_SUCCESS:
      return {
        type: 'success',
        agendamentos: action.agendamentos,
      };
    case agendamentoConstants.AGENDAMENTO_FAILURE:
      return Object.assign({}, state, {
        type: 'failure',
        agendamentos: {},
      });
    case agendamentoConstants.AGENDAMENTO_REQUEST:
      return Object.assign({}, state, {
        type: 'request',
      });
    default:
      console.debug('notification reducer :: hit default', action.type);
      return state;
  }
}
